import { observer } from 'mobx-react-lite'
import { OCRScopeNewJobButtonContainer } from '@/features/jobs/scoping/components/OCRScopeNewJobButton/OCRScopeNewJobButtonContainer'
import { type CreateOCRScopeJobsViewModel } from '@/features/jobs/scoping/components/CreateOCRScopeJobsDialog/CreateOCRScopeJobsViewModel'
import { type OCRScopingJobSidePanelViewModel } from '@/features/jobs/scoping/OCRScopingJobSidePanelViewModel'
import { OCRBulkActionButton } from '@/features/jobs/scoping/components/OCRBulkActionButton'

export interface OCRBulkActionButtonContainerProps {
  vm: OCRScopingJobSidePanelViewModel
  createScopeJobsVm: CreateOCRScopeJobsViewModel
}

export const OCRBulkActionButtonContainer = observer(
  function OCRBulkActionButtonContainer({
    vm,
    createScopeJobsVm,
  }: OCRBulkActionButtonContainerProps) {
    const bulkAction = vm.selectedStatusFilter?.bulkAction
    if (!bulkAction) {
      return (
        <OCRScopeNewJobButtonContainer vm={createScopeJobsVm} wideSlimButton />
      )
    }

    return (
      <OCRBulkActionButton
        bulkActionName={bulkAction.name}
        isDisabled={
          !vm.bulkActionVm.hasAnyItemsSelectedForBulkAction ||
          bulkAction.task.pending
        }
        onPress={bulkAction.confirm}
      />
    )
  },
)
